import * as React from "react";
import Svg, { Path, Circle } from "react-native-svg";

function SvgComponent(props) {
  return (
    <Svg
      {...props}
      width={20}
      height={20}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <Path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M2.691 4.722h11.285c.72 0 1.302.583 1.302 1.302V17.31c0 .72-.583 1.302-1.302 1.302H2.691c-.719 0-1.302-.583-1.302-1.302V6.024c0-.719.583-1.302 1.302-1.302zm9.857 6.64l1.862 1.863v-7.2a.434.434 0 00-.434-.435H2.691a.434.434 0 00-.434.434v8.937l4.037-4.032a.434.434 0 01.612 0l2.73 2.73 2.3-2.296a.434.434 0 01.612 0zM7.465 8.629a1.736 1.736 0 113.472 0 1.736 1.736 0 01-3.472 0zm.868 0a.868.868 0 101.736 0 .868.868 0 00-1.736 0z"
        fill="#000"
        fillOpacity={0.86}
      />
      <Circle cx={15} cy={5} r={5} fill="#fff" />
      <Path
        d="M15 7.56V1.666m2.946 2.946h-5.892"
        stroke="#000"
        strokeOpacity={0.86}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </Svg>
  );
}

export default SvgComponent;
